import { render, staticRenderFns } from "./StepSecond.vue?vue&type=template&id=0df9f0b6&lang=pug&"
import script from "./StepSecond.vue?vue&type=script&lang=js&"
export * from "./StepSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports